import { memo, useEffect } from 'react';

import { useViewerEmail } from '@/entities/viewer';

type ClarityFunction = (method: string, ...args: string[]) => void;

export const ClarityIdentify = memo(() => {
    const email = useViewerEmail();

    useEffect(() => {
        if (!__IS_DEV__ && !__IS_STAGE__ && email) {
            const { clarity } = window as unknown as {
                clarity?: ClarityFunction;
            };

            clarity?.('identify', email);
        }
    }, [email]);

    return null;
});

ClarityIdentify.displayName = 'ClarityIdentify';
